import api from '../_api'
import {
    FETCH_ASSIGNED_CARD_ACCOUNTS_REQUEST,
    FETCH_ASSIGNED_CARD_ACCOUNTS_SUCCESS,
    FETCH_ASSIGNED_CARD_ACCOUNTS_FAILED,
    FETCH_ASSIGNED_CARD_PAYMENT_INFO_REQUEST,
    FETCH_ASSIGNED_CARD_PAYMENT_INFO_SUCCESS,
    FETCH_ASSIGNED_CARD_PAYMENT_INFO_FAILED
} from './mutation-type'

const fetchAssignedCardAccounts = async ({ commit, state, getters, rootGetters }, { usageAccountIds, projectIdxs }) => {
    commit(FETCH_ASSIGNED_CARD_ACCOUNTS_REQUEST)
    try {
        const { status, data } = await api.fetchAssignedCardAccounts({ usageAccountIds, projectIdxs }, rootGetters.requiredService)
        commit(FETCH_ASSIGNED_CARD_ACCOUNTS_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(FETCH_ASSIGNED_CARD_ACCOUNTS_FAILED, error)
        throw error
    }
}

const fetchAssignedCardPaymentInfo = async ({ commit, state, getters, rootGetters }, { assignedIdxs, projectIdxs }) => {
    commit(FETCH_ASSIGNED_CARD_PAYMENT_INFO_REQUEST)
    try {
        const { status, data } = await api.fetchAssignedCardPaymentInfo({ assignedIdxs, projectIdxs }, rootGetters.requiredService)
        commit(FETCH_ASSIGNED_CARD_PAYMENT_INFO_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(FETCH_ASSIGNED_CARD_PAYMENT_INFO_FAILED, error)
    }
}

export default {
    fetchAssignedCardAccounts,
    fetchAssignedCardPaymentInfo
}
